import script from './SdsGlobalHeaderIconMobile.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sds-global-header-icon sds-focus",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('SdsIcon',{attrs:{"iconName":_vm.iconName,"size":"lg"}}),_vm._v(" "),(_vm.hasNotification)?_c('div',{staticClass:"sds-global-header-icon--indicator"}):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-a9d3801a_0", { source: ".sds-global-header-icon[data-v-a9d3801a]{position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:auto;height:auto;margin:0;padding:8px;background:0 0;border:none;color:var(--component-global-header-graphics-primary);cursor:pointer}.sds-global-header-icon--indicator[data-v-a9d3801a]{position:absolute;top:6px;right:10px;height:4px;width:4px;background-color:var(--component-global-header-graphics-notification-indicator);border-radius:var(--radius-full)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-a9d3801a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
